import {imgOpenStretch} from "../assets/images/open_stretch.js";
import {imgVojlock} from "../assets/images/vojlock.js";
import {img1000m} from "../assets/images/1000m.js";
import {imgV75} from "../assets/images/v75.js";
import {imgMonte} from "../assets/images/monte.js";
import {imgEkipage} from "../assets/images/ekipage.js";
import {imgDistans} from "../assets/images/distans.js";
import {imgFidus} from "../assets/images/fidus.js";
import {imgSulky} from "../assets/images/sulky.js";
import {imgGoop} from "../assets/images/goop.js";
import {imgV75Premiar} from "../assets/images/v75-premiar.js";
import {imgM8Distans} from "../assets/images/m8_distans.js";
import {imgTjuvStart} from "../assets/images/tjuvstart.js";
import {imgStrecka} from "../assets/images/strecka.js";
import {imgMapSweden} from "../assets/images/map_sweden.js";
import {imgHastraser} from "../assets/images/hastraser.js";
import {imgGaffelBand} from "../assets/images/gaffelband.js";
import {imgStartbil} from "../assets/images/startbil.js";
import {imgValack} from "../assets/images/valack.js";
import {imgDD} from "../assets/images/dd.js";
import {imgMalgang} from "../assets/images/malgang.js";
import {imgDoseRing} from "../assets/images/dosering.js";
import {imgTingsryd} from "../assets/images/tingsryd.js";

export const CHAMPION_QUIZZES = [
  {
    question: "Vad är <span style='color:#FFDE00'>open stretch?</span>",
    options: [
      "Extraspår som bara används i starten",
      "Den sista minuten av respektive lopp",
      "En plats där det är tillåtet att klappa en häst",
      "En utrustningsdetalj på travhästen",
      "Extraspår som bara används på upploppet",
    ],
    answer: "Extraspår som bara används på upploppet",
    backgroundImageUrl: imgOpenStretch,
    showRadio: true,
  },
  {
    question:
      "Vad kallas positionen <span style='color:#FFDE00'>utvändigt</span> om ledarhästen?",
    options: [
      "Kylboxen",
      "Dödens",
      "Hetväggen",
      "Spetsen",
      "Andra par utvändigt",
    ],
    answer: "Dödens",
    videoUrl: '/C2_dodens.mp4',
    showRadio: true,
  },
  {
    question: "Vad är en <span style='color:#FFDE00'>vojlock?</span>",
    options: [
      "En startmetod",
      "En typ av foder",
      "Hästens nummerbricka",
      "En utrustningsdetalj på travhästen",
      "Kuskens hjälm",
    ],
    answer: "Hästens nummerbricka",
    backgroundImageUrl: imgVojlock,
    showRadio: true,
  },
  {
    question:
      "Vilken är den <span style='color:#FFDE00'>vanligaste längden</span> på travbanor i Sverige?",
    options: ["0", "1000", "1200", "1400", "1600", "1800"],
    answer: "1000",
    unit: "M",
    backgroundImageUrl: img1000m,
    showSlider: true,
  },
  {
    question:
      "I <span style='color:#FFDE00'>vilken avdelning</span> på V75® avgörs TOP 7®?",
    answer: "V75-5",
    options: ["V75-1", "V75-2", "V75-3", "V75-4", "V75-5"],
    backgroundImageUrl: imgV75,
    showTimeline: true,
  },
  {
    question: "Vad är <span style='color:#FFDE00'>monté?</span>",
    options: [
      "Franska för häst",
      "Travlopp där ryttaren sitter på hästen",
      "En hästras",
      "Toppen av en travhästs karriär",
      "Den tuffaste konkurrenten i ett lopp",
    ],
    answer: "Travlopp där ryttaren sitter på hästen",
    backgroundImageUrl: imgMonte,
    showRadio: true,
  },
  {
    question:
      "Sveriges absolut <span style='color:#FFDE00'>kortaste upplopp</span> hittar vi på vilken bana?",
    options: ["Visby", "Arvika", "Örebro", "Bollnäs", "Åmål"],
    answer: "Arvika",
    backgroundImageUrl: imgMapSweden,
    showMapOptions: true,
     positions: [
      {top: -120, left: 5, mobileTop: -68, mobileLeft: 0, placement: "end"},
      {top: -210, left: -210, mobileTop: -120, mobileLeft: -127, placement: "start"},
      {top: -200, left: -60, mobileTop: -110, mobileLeft: -35, placement: "end"},
      {top: -285, left: -50, mobileTop: -150, mobileLeft: -30, placement: "end"},
      {top: -180, left: -200, mobileTop: -100, mobileLeft: -120, placement: "start"},
    ],
  },
  {
    question:
      "<span style='color:#FFDE00'>Häst och kusk</span> i ett lopp kallar vi vadå?",
    options: ["Ekipering", "Radarpar", "Eskipange", "Ekipage", "Ekopar"],
    answer: "Ekipage",
    backgroundImageUrl: imgEkipage,
    showRadio: true,
  },
  {
    question:
      "Vilken av distanserna är vanligast förekommande som <span style='color:#FFDE00'>lång distans?</span>",
    options: ["0", "1000", "1609", "2140", "2640", "3500"],
    answer: "2640",
    unit: "M",
    backgroundImageUrl: imgDistans,
    showSlider: true,
  },
  {
    question:
      "Hur många <span style='color:#FFDE00'>travbanor</span> finns det i Sverige?",
    options: ["15", "28", "31", "33", "38"],
    answer: "33",
    showLargeOptionsWithMap: true,
    videoUrl: "/C10.mp4",
  },
];

export const MASTER_QUIZZES = [
  {
    question:
      "<span style='color:#FFDE00'>Sveriges längsta upplopp</span> (300 meter) hittar du på vilken bana?",
    options: ["Axevalla", "Tingsryd", "Kalmar", "Solvalla", "Åby"],
    positions: [
      {top: -160, left: -200, mobileTop: -95, mobileLeft: -120, placement: "start"},
      {top: -50, left: -175, mobileTop: -35, mobileLeft: -130, placement: "start"},
      {top: -72, left: -40, mobileTop: -50, mobileLeft: -30, placement: "end"},
      {top: -200, left: 0, mobileTop: -110, mobileLeft: 0, placement: "end"},
      {top: -72, left: -175, mobileTop: -50, mobileLeft: -130, placement: "start"},
    ],
    answer: "Tingsryd",
    backgroundImageUrl: imgMapSweden,
    showMapOptions: true,
  },
  {
    question: "<span style='color:#FFDE00'>Fidus</span> är ett annat ord för?",
    options: ["Favoriten", "Ledaren", "Gamlingen", "Outsidern", "Nybörjaren"],
    answer: "Outsidern",
    backgroundImageUrl: imgFidus,
    showRadio: true,
  },
  {
    question:
      "Vad heter <span style='color:#FFDE00'>vagnen</span> bakom hästen?",
    options: ["Jockey", "Travkärra", "Manbag", "Skrinda", "Sulky"],
    answer: "Sulky",
    backgroundImageUrl: imgSulky,
    showRadio: true,
  },
  {
    question: "I voltstart får man inte använda…",
    options: [
      "Amerikansk vagn",
      "Rycktussar",
      "Vanlig sulky",
      "Hästskor",
      "Hjälm",
    ],
    answer: "Amerikansk vagn",
    videoUrl: '/m4_voltstart.mp4',
    showRadio: true,
  },
  {
    question:
      "Vilket är <span style='color:#FFDE00'>efternamnet</span> på en av Sveriges mest kända kuskar?",
    options: ["Grop", "Scoop", "Goop", "Loop", "Snoop"],
    answer: "Goop",
    backgroundImageUrl: imgGoop,
    showRadio: true,
  },
  {
    question:
      "<span style='color:#FFDE00'>Hur många montéhästar</span> får plats i det främre ledet bakom startbilen i Sverige?",
    options: ["0", "8", "10", "12", "14", "16"],
    answer: "10",
    unit: "ST",
    videoUrl: '/m6_montehastar.mp4',
    showSlider: true,
  },
  {
    question: "När <span style='color:#FFDE00'>startade</span> V75®?",
    options: ["1974", "1987", "1993", "1999", "2022"],
    answer: "1993",
    backgroundImageUrl: imgV75Premiar,
    showRadio: true,
  },
  {
    question:
      "<span style='color:#FFDE00'>En stayer</span> kallas en häst som trivs bäst över…",
    options: ["Kort distans", "Medeldistans", "Lång distans"],
    answer: "Lång distans",
    backgroundImageUrl: imgM8Distans,
    showRadio: true,
  },
  {
    question:
      "Efter hur många <span style='color:#FFDE00'>tjuvstarter</span> får ett ekipage inte tävla vidare?",
    options: ["1", "2", "3", "4", "5"],
    answer: "2",
    backgroundImageUrl: imgTjuvStart,
    showLargeOptions: true,
  },
  {
    question:
      "När man bara streckar <span style='color:#FFDE00'>en häst</span> i en avdelning på exempelvis V75 brukar man säga att man...",
    options: ["Skruvar", "Filar", "Spikar", "Garderar", "Sätter den"],
    answer: "Spikar",
    backgroundImageUrl: imgStrecka,
    showRadio: true,
  },
];

export const WINNER_QUIZZES = [
  {
    question:
      "Åby är en av två svenska banor med extraspår <span style= 'color:#FFDE00'>på upploppet.</span> Vilken är den andra?",
    options: ["Skellefteå", "Halmstad", "Solvalla", "Hoting", "Boden"],
    answer: "Skellefteå",
    positions: [
      {top: -460, left: 70, mobileTop: -240, mobileLeft: 30, placement: "end"},
      {top: -68, left: -125, mobileTop: -45, mobileLeft: -65, placement: "end"},
      {top: -200, left: 0, mobileTop: -110, mobileLeft: 0, placement: "end"},
      {top: -430, left: -130, mobileTop: -220, mobileLeft: -90, placement: "start"},
      {top: -510, left: 100, mobileTop: -265, mobileLeft: 45, placement: "end"},
    ],
    backgroundImageUrl: imgMapSweden,
    showMapOptions: true,
  },
  {
    question:
      "Vilken hästras <span style = 'color:#FFDE00'>är vanligast</span> på svenska travbanor?",
    options: [
      "Islandshäst",
      "Russ",
      "Nordsvensk brukshäst",
      "Kallblod",
      "Varmblod",
    ],
    answer: "Varmblod",
    backgroundImageUrl: imgHastraser,
    showRadio: true,
  },
  {
    question: "<span style = 'color:#FFDE00'>Rygg ledaren</span> kallas också?",
    options: [
      "Vinnarhålet",
      "Guldstället",
      "Smygen",
      "Prispallen",
      "Bakvinnaren",
    ],
    answer: "Vinnarhålet",
    videoUrl: '/V3_ryggledaren.mp4',
    showRadio: true,
  },
  {
    question: "Vad är <span style ='color:#FFDE00'>ett gaffelband?</span>",
    options: [
      "En utrustningsdetalj",
      "En tredelad sele",
      "En sena på baksidan av hästens underben",
      "Hästens motsvarighet till stämband",
      "Stallredskap",
    ],
    answer: "En sena på baksidan av hästens underben",
    backgroundImageUrl: imgGaffelBand,
    showRadio: true,
  },
  {
    question:
      "Hur många travhästar med sulky <span style = 'color:#FFDE00'>får plats i det främre ledet</span> bakom startbilen i Sverige?",
    options: ["6", "7", "8", "9", "10"],
    answer: "8",
    backgroundImageUrl: imgStartbil,
    showLargeOptions: true,
  },
  {
    question: "Vad är <span style='color:#FFDE00'>en valack?</span>",
    options: [
      "Kastrerad hingst",
      "En speciell hästsko",
      "Vagnen bakom hästen",
      "En ungersk ponny",
      "Typ av sadel",
    ],
    answer: "Kastrerad hingst",
    backgroundImageUrl: imgValack,
    showRadio: true,
  },
  {
    question:
      "<span style= 'color:#FFDE00'>Hur många rätt</span> måste du ha för att vinna på Dagens Dubbel®?",
    options: ["1", "2", "3", "4", "5"],
    answer: "2",
    backgroundImageUrl: imgDD,
    showLargeOptions: true,
  },
  {
    question:
      "Vad betyder att en häst har <span style = 'color:#FFDE00'>ett staket?</span>",
    options: [
      "Tre raka förluster",
      "Glest mellan tänderna",
      "En seger",
      "Rejäla magmuskler",
      "Fem raka segrar",
    ],
    answer: "Fem raka segrar",
    backgroundImageUrl: imgMalgang,
    showRadio: true,
  },
  {
    question: "Vad är <span style= 'color:#FFDE00'>dosering?</span>",
    options: [
      "Hästens matranson",
      "Banans lutning i kurvorna",
      "Banans material",
      "Mängden hö i en viss skulle",
      "Antal fel på en V75-kupong",
    ],
    answer: "Banans lutning i kurvorna",
    backgroundImageUrl: imgDoseRing,
    showRadio: true,
  },
  {
    question:
      "<span style = 'color:#FFDE00'>Hur lång</span> är banan i Tingsryd?",
    options: ["0", "800", "1000", "1609", "2140", "2900"],
    answer: "1609",
    unit: "M",
    backgroundImageUrl: imgTingsryd,
    showSlider: true,
  },
];
